/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';
import { Action, ActionType } from '../actionTypes/zoneImageActionTypes';
import { IZoneImage as ZoneImage, IReportZoneImage as ReportZoneImage } from '../../models/zoneImage';

export interface IZoneImageState {
    zoneImages: ZoneImage[];
    reportZoneImages: ReportZoneImage[];
    loading: boolean;
    error: string | null,
}
const initialState = {
    zoneImages: [],
    reportZoneImages: [],
    loading: false,
    error: null,   
};
export const ZoneImageReducer: Reducer<IZoneImageState, Action> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ActionType.FETCH_ZONEIMAGES:
        case ActionType.ADD_ZONEIMAGE:
        case ActionType.EDIT_ZONEIMAGE:
        case ActionType.DELETE_ZONEIMAGE:
            return { ...state, loading: true };

        case ActionType.FETCH_ZONEIMAGES_FAIL:
        case ActionType.ADD_ZONEIMAGE_FAIL:
        case ActionType.EDIT_ZONEIMAGE_FAIL:
        case ActionType.DELETE_ZONEIMAGE_FAIL:
            return { 
                ...state, 
                loading: false,
                error: action.payload
            };

        case ActionType.ADD_ZONEIMAGE_SUCCESS:
            // console.log("action.payload Add: ", action.payload.data)
            return {
                ...state,
                zoneImages: [ ...state.zoneImages, action.payload.data ],
                loading: false
            };

        case ActionType.FETCH_ZONEIMAGES_SUCCESS:
            return {
                ...state,
                zoneImages: action.payload.data,
                loading: false
            };

        case ActionType.EDIT_ZONEIMAGE_SUCCESS:
            const zoneImage = action.payload.data
            const index = state.zoneImages.findIndex(itm => itm.zoneimageid === zoneImage.zoneimageid)
            const zoneImagePart1 = state.zoneImages.slice(0, index)
            const zoneImagePart2 = state.zoneImages.slice(index + 1)
            return {
                ...state,
                zoneImages: [ ...zoneImagePart1, zoneImage, ...zoneImagePart2 ],
                loading: false
            };
        case ActionType.DELETE_ZONEIMAGE_SUCCESS:
            return {
                ...state,
                zoneImages: state.zoneImages.filter(zoneImage => zoneImage.zoneimageid !== action.payload),
            };
        case ActionType.FETCH_REPORTZONEIMAGES_SUCCESS:
            return {
                ...state,
                reportZoneImages: action.payload.data,
                loading: false
            }
        default:
            return state;
    }
};
